import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { navigateWithFreshRoute } from 'src/app/shared/route-reuse.util';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { CreditModelComponent } from 'src/app/components/credit/credit-model/credit-model.component';
import { countProvider } from 'src/app/components/suggestions/suggestions.component';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { SearchData } from 'src/app/services/searchData';
import { ApiService } from './../../services/api.service';
import { UtilService } from './../../services/util.service';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CommonProfileInfoComponent } from 'src/app/widget/common-profile-info/common-profile-info.component';
import { CandidateCardComponent } from 'src/app/components/cards/candidate-card/candidate-card.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-suggested-candidate',
  standalone: true,
  imports: [
    CommonModule,
    CommonSkeletonComponent,
    CommonProfileInfoComponent,
CandidateCardComponent,
    InfiniteScrollModule
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './suggested-candidate.component.html',
  styleUrls: ['./suggested-candidate.component.scss']
})
export class SuggestedCandidateComponent implements OnInit, OnChanges {
  img: any = 'assets/images/userAvatar.png';
  userType = localStorage.getItem('userType');
  @Input() widgetDesc: string;
  @Input() page: number;
  @Input() suggestion: any;
  headerTitle: string = 'Marketplace Candidates';
  candidatefilter
  @Input() inputData: string;
  suggestionBehavior = new BehaviorSubject<any[]>([]);
  prevAfterKey : string = "";
  stopScroll : boolean =  false;
  bsModalRef: BsModalRef;
  loadAPIcall:boolean=false;
  jobId
  src: any;
  totalCount: any;
  configlist = {
    itemsPerPage: 5,
    currentPage: 1
  }
  pathdata: any;
  @Input() maxMin: any = {};
  viewType: string = "MIN";
  data = {
    userId: localStorage.getItem('userId'),
    searchAfterKey: null,
    limit: 10,
  };
  sugges = null
  sugCandiCount: any;
  count: any;

  constructor(private a_route: ActivatedRoute, private modalService: BsModalService, private router: Router, private apiService: ApiService, private searchdata: SearchData,
    private util: UtilService, private provider: countProvider, private candidateService: CandidateService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any) {
    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      if (this.widgetData.maxMin) {
        this.maxMin = this.widgetData.maxMin;
        if (this.widgetData.maxMin.viewType) {
          this.viewType = this.widgetData.maxMin.viewType;
        }
      }
      if (this.widgetData.widgetDesc) {
        this.headerTitle = this.normalizeTitle(this.widgetData.widgetDesc);
      }
      if (this.widgetData.inputData) {
        this.inputData = this.widgetData.inputData;
      }
      if (this.widgetData.page !== undefined) {
        this.page = this.widgetData.page;
      }
    }
  }

  // Normalize title to use "Marketplace" instead of "Suggested"
  private normalizeTitle(title: string): string {
    if (!title) return this.headerTitle;
    if (title.toLowerCase().includes('suggested candidate')) {
      return 'Marketplace Candidates';
    }
    return title;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle maxMin changes - critical for showing MAX view on suggestions page
    if (changes.maxMin) {
      const newMaxMin = changes.maxMin.currentValue;
      if (newMaxMin) {
        this.maxMin = newMaxMin;
        if (newMaxMin.viewType) {
          this.viewType = newMaxMin.viewType;
        }
      }
    }
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = this.normalizeTitle(changes.widgetDesc.currentValue);
    }
  }

  click: boolean;
  ngOnInit() {
    if (this.maxMin && this.maxMin.viewType) {
      this.viewType = this.maxMin.viewType;
    }

    this.searchdata.getWidget().subscribe(res => {
      this.click = res
    });
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.normalizeTitle(this.widgetDesc);
    }
    this.a_route.queryParams.subscribe((res) => {
      this.jobId = res.jobId;



      this.candidatefilter = res.jobfilter;

      this.pathdata = res.count;
      this.totalCount = this.pathdata;
      if (res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = this.normalizeTitle(res.menu);
      }


      if (this.maxMin.viewType != undefined) {
        this.viewType = "MAX";
        this.inputData = this.maxMin.master;
      }
      if (res.singleCandiS == "true") {
        this.getSingleCandi(res.id, false)
      } else {
        this.getcandidate();
      }
    })


    var a = this.a_route.pathFromRoot[0]['_routerState']['snapshot'].url
    var b = a.substring(0, 20)
    if (b == '/newcandidates?jobId') {
      this.candidatefilter = "true";
    } if (b == '/newjobs?candidateId') {
      this.candidatefilter = "true";
    }

  }

  openModalWithComponent() {

    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "open"
    };
    this.bsModalRef = this.modalService.show(CreditModelComponent, initialState);


  }


  refereshSuggestedCandidate() {
    this.data.searchAfterKey=null
    this.getcandidate();
  }

  listLength
  getdatafromjob() {


    this.apiService.query("jobs/findJobById/" + this.jobId).subscribe((res) => {
      let datas = res.data.jobData;
      datas.userId = localStorage.getItem('userId');
      datas.pageNumber = 0;
      datas.limit = 10;
      datas.findAll = false;

      this.apiService.create("candidates/findSuggestedCandidates", datas).subscribe((res) => {
        // this.util.stopLoader();
        if (res.data.candidateList){
          this.suggestionBehavior.next(res.data.candidateList);
          this.listLength = this.suggestionBehavior.getValue().length;

          this.count = res.data.totalCandidates
          this.sugCandiCount = res.data.candidateList.length;
        }
        // this.src= AppSettings.photoUrl + res.data.candidateList.user.photo;

        // if (res.data.findAll) {
        //   this.data.findAll = true
        //   this.data.pageNumber = 0;

        // } else {
        //   this.data.findAll = false;
        // }
        if (res.data.totalCandidates) {
          this.totalCount = res.data.totalCandidates;
        }


      })


    })
  }
  resultContent: string = "";
  totalcandidates: number = 10;

  getcandidate() {

    if(this.suggestionBehavior === undefined || Array.isArray(this.suggestionBehavior)){
      this.suggestionBehavior = new BehaviorSubject<any[]>([]);
    }
    this.loadAPIcall=true;
    this.apiService.create("candidates/findSuggestedCandidates", this.data).subscribe((res) => {
      this.loadAPIcall=false;
      if (!res) { return; }
      if (res.code === GigsumoConstants.SUCESSCODE && res.data && res.data.candidateList != undefined) {
        const afterKey = res.data.searchAfterKey && res.data.searchAfterKey[0];
        const resData = res.data.candidateList;


        if(this.prevAfterKey === afterKey || resData.length === 0){
          this.stopScroll = true;
          this.util.stopLoader();
          return;
        }

        const data = resData.map(ele => {
          const d  ={
            ...ele,
            user: {
              ...ele.user,
              photo: ele.user.photo != null ? AppSettings.photoUrl + ele.user.photo : null
            }
          }
          return d;
        });

          const combined = [...this.suggestionBehavior.getValue(), ...data];
          this.suggestionBehavior.next(combined);

        this.prevAfterKey = afterKey;
        if (res.data.totalCandidates != undefined && res.data.totalCandidates != null) {
          this.totalcandidates = res.data.totalCandidates;
          this.provider.setCount(this.totalcandidates , "SuggestedCandidateComponent");
        }

        if (resData == null || (resData != null && resData.length === 0)) {
          this.resultContent = "NULL";
        }

      }
      else if (res.code == '99999') {
        this.suggestionBehavior.next([]);
      }

      this.util.stopLoader();

    }, (error) => {
      this.loadAPIcall = false;
      this.util.stopLoader();
    });
  }



  modelopen(data, show, candiid) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.singleCandiS = show;
    dataPass.id = candiid;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Marketplace Candidates';
    dataPass.master = this.page;
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "SuggestedCandidateComponent";
    dataPass.count = this.totalCount;

    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }


  async redirect(val) {
    // Route reuse is disabled per-navigation inside navigateWithFreshRoute; the
    // old inline override here leaked to the whole session.
    if (val.createdBy != localStorage.getItem('userId') && !val.isViewed &&
      this.userType != 'JOB_SEEKER') {
      // const userData = await this.planService.UPDATE_USERDETAILS("RESUME_VIEWS");
      // if (userData.isExpired) {
      //   let availablePoints = null;
      //   let actualPoints = null;
      //   let utilizedPoints = null;
      //   userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
      //     if (ele.benefitKey == 'RESUME_VIEWS') {
      //       availablePoints = ele.available
      //       actualPoints = ele.actual
      //       utilizedPoints = ele.utilized
      //     }
      //   })
      //   this.planService.expiredPopup("RESUME_VIEWS", "PAY", null, null, null, availablePoints, actualPoints, utilizedPoints);

      //   return;
      // }
      // else {
      this.updateView(val);
      //}
    }
    else {
      navigateWithFreshRoute(this.router, ['newcandidates'], { queryParams: { candidateId: val.candidateId, tabName: 'profileSummary', From: 'SUGGESTED_CANDIDATES' } })
    }
  }



  updateView(val) {
    this.candidateService.updateCandidateViewed(val).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        navigateWithFreshRoute(this.router, ['newcandidates'], { queryParams: { candidateId: val.candidateId, tabName: 'profileSummary', From: 'SUGGESTED_CANDIDATES' } })
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  getSingleCandi(candiId, clickable) {

    if (candiId != null) {
      this.apiService.query("candidates/findCandidateById/" + candiId).subscribe((res) => {
        this.sugges = res.data.candidateData;
        if (clickable && this.click == true) {
          this.modelopen(this.sugges, true, candiId)
        }
      });

    }
  }

  onScrollDown(){
    if (!this.stopScroll && this.data.searchAfterKey != this.prevAfterKey) {
      this.data.searchAfterKey = this.prevAfterKey === null ? null
      : [this.prevAfterKey];
      this.getcandidate();
    }
  }
}
